module.exports = __webpack_public_path__ + "img/emm_icon03.181c767d.png";